import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { AxisStructuredData } from '../../../../../../Typescript/backend/classes/AxisStructuredData';
import {
  getAxisStructuredDataIndustryLabel,
  getAxisStructuredDataSubIndustryLabel,
  getAxisStructuredDataTypeLabel,
} from '../../../../../Axis/axisStructuredDataLabels';

interface QuoteAxisStructuredDataDisplayProps {
  axisStructuredData: AxisStructuredData | null;
}

export const QuoteAxisStructuredDataDisplay = ({
  axisStructuredData,
}: QuoteAxisStructuredDataDisplayProps) => {
  if (!axisStructuredData?.hasDisplayFields()) {
    return null;
  }

  const typeLabel = getAxisStructuredDataTypeLabel(axisStructuredData.type);
  const industryLabel = getAxisStructuredDataIndustryLabel(
    axisStructuredData.industry,
  );
  const subIndustryLabel = getAxisStructuredDataSubIndustryLabel(
    axisStructuredData.subIndustry,
  );

  return (
    <Outer>
      <Heading variant='overline'>Inquiry details</Heading>
      {typeLabel ? (
        <DetailRow variant='body2'>
          <DetailLabel>Type:</DetailLabel> {typeLabel}
        </DetailRow>
      ) : null}
      {industryLabel ? (
        <DetailRow variant='body2'>
          <DetailLabel>Industry:</DetailLabel> {industryLabel}
        </DetailRow>
      ) : null}
      {subIndustryLabel ? (
        <DetailRow variant='body2'>
          <DetailLabel>Sub-industry:</DetailLabel> {subIndustryLabel}
        </DetailRow>
      ) : null}
    </Outer>
  );
};

const Outer = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(3),
  minWidth: 220,
}));

const Heading = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  display: 'block',
  marginBottom: theme.spacing(1),
}));

const DetailRow = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
}));

const DetailLabel = styled('span')({
  fontWeight: 600,
});
